const Button = theme => {
  return {
    MuiButton: {
      defaultProps: {
        size: 'medium'
      },
      styleOverrides: {
        root: {
          fontWeight: theme.typography.fontWeightMedium,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        },
        containedInherit: {
          border: 'none'
        }
      }
    }
  };
};

export { Button };
